import './index.scss';

import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import useSWR from 'swr';

import axios from '../../admin-axios';
import { ReactComponent as CashIcon } from '../../assets/Images/cash_icon.svg';
import LongPaginationHandler from '../../components/LongPaginationHandler';
import SearchAndFilter from '../../components/SearchAndFilter';
import { detectError, nFormatter } from '../../utils';

const fetcher = (url) => axios.get(url).then((res) => res.data);
const DebtRepayment = () => {
  const [page, setPage] = useState(1);
  const [tableView, setTableView] = useState('normal');
  const [filterResult, setFilterResult] = useState([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterPage, setFilterPage] = useState(1);
  const [filterTotal, setFilterTotal] = useState(0);
  const [filterPerPage, setFilterPerPage] = useState(20);
  const [filterError, setFilterError] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchError, setSearchError] = useState(false);

  const dateRef = useRef(null);
  const searchRef = useRef();
  const tableDate = useRef('2022-11-17');
  const {
    user: { stationId }
  } = useSelector((state) => state.auth);

  const {
    data,
    error,
    isLoading: loading
  } = useSWR(`/debt/repayment/history/${stationId}?page=${page}`, fetcher);

  if (error) {
    toast.error(detectError(error));
  }

  const searchHandler = async (event) => {
    if (event.code === 'Enter') {
      if (!searchRef.current.value) {
        toast.error('Please enter a valid transaction ID');
        return;
      }

      setTableView('searching');
      try {
        setLoadingSearch(true);
        const res = await axios.get(
          `/debt/repayment/search/${searchRef.current.value}/${stationId}`
        );
        setSearchResult(res.data.data.data);
        setTableView('searching');
        setLoadingSearch(false);
      } catch (e) {
        setSearchError(detectError(e));
      }
      searchRef.current.value = '';
    }
  };

  const paginate = (pageNumber) => {
    setPage(pageNumber);
  };

  const paginateFilter = (pageNumber) => {
    setFilterPage(pageNumber);
  };

  const filterByDateHandler = async () => {
    if (!dateRef.current.value) {
      toast.error('Please choose a date to filter by');
      return;
    }
    const toSend = {
      date: dateRef.current.value
    };

    try {
      setFilterLoading(true);
      setTableView('filtering');
      const res = await axios.post(`debt/repayment/history/filter/${stationId}`, toSend);
      setFilterResult(res.data.data.data);
      setFilterPage(res.data.data.current_page);
      setFilterTotal(res.data.data.total);
      setFilterPerPage(res.data.data.per_page);
      setFilterLoading(false);
    } catch (e) {
      setFilterError(detectError(e));
      setFilterLoading(false);
    }
  };

  useEffect(() => {
    if (filterPage && dateRef.current?.value) {
      filterByDateHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPage]);

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="w-100 h-100 dw_record">
      <div className="row mb-5">
        <div className="col-lg-4">
          <div className="dw_record_box dw_record_green_img w-100">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center w-100 h-100">
                <Spinner className="spinner" animation="border" variant="dark" />
              </div>
            ) : (
              <>
                <CashIcon />
                <p className="dw_record_box_main_text">
                  NGN
                  {data && nFormatter(data.total_debt_today)}
                </p>
                <p className="dw_record_box_sub_text">Total debt repaid today</p>
              </>
            )}
          </div>
        </div>
        <div className="col-lg-4 my-2 my-lg-0">
          <div className="dw_record_box dw_record_purple_img w-100">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center w-100 h-100">
                <Spinner className="spinner" animation="border" variant="light" />
              </div>
            ) : (
              <>
                <CashIcon />
                <p className="dw_record_box_main_text">
                  NGN
                  {data && nFormatter(data.total_debt_yestarday)}
                </p>
                <p className="dw_record_box_sub_text">Total debt repaid yesterday</p>
              </>
            )}
          </div>
        </div>
        <div className="col-lg-4">
          <div className="dw_record_box dw_record_purple_img w-100">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center w-100 h-100">
                <Spinner className="spinner" animation="border" variant="light" />
              </div>
            ) : (
              <>
                <CashIcon />
                <p className="dw_record_box_main_text">
                  NGN
                  {data && nFormatter(data.total_debt_last_month)}
                </p>
                <p className="dw_record_box_sub_text">Total debt repaid last month</p>
              </>
            )}
          </div>
        </div>
      </div>
      <SearchAndFilter
        searchRef={searchRef}
        dateRef={dateRef}
        filterByDateHandler={filterByDateHandler}
        searchHandler={searchHandler}
        searchText="Search by Transaction ID"
      />
      {(tableView === 'searching' || tableView === 'filtering') && (
        <div className="">
          <button
            onClick={() => setTableView('normal')}
            type="button"
            className="mb-3 btn unapproved_transactions_general_button">
            Back to All Debt Record
          </button>
        </div>
      )}
      <div className="dw_record_table_wrapper">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Transaction ID</th>
              <th scope="col">Customer Type</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Phone No.</th>
              <th scope="col">Amount Repaid</th>
              {/* <th scope="col">Status</th> */}
            </tr>
          </thead>
          {tableView === 'normal' && (
            <tbody>
              {loading && (
                <tr className="py-3">
                  <td colSpan={6}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {error && (
                <tr>
                  <td colSpan={6}>
                    <div className="d-flex justify-content-center w-100">
                      <p className="text-danger">{error}</p>
                    </div>
                  </td>
                </tr>
              )}
              {data &&
                data.data.data.length > 0 &&
                data.data.data.map((tx, index) => {
                  const date = new Date(tx.created_at).toDateString();
                  if (date !== tableDate.current) {
                    tableDate.current = date;
                    return (
                      <React.Fragment key={index}>
                        <tr className="unapproved_transactions_table_date_text text-end">
                          <td className="p-0" colSpan="7">
                            {new Date(tableDate.current).toDateString()}
                          </td>
                        </tr>
                        <tr>
                          <td>{tx.transaction_id}</td>
                          <td>{tx.customer_type}</td>
                          <td>{`${tx.customer_lastname} ${tx.customer_firstname}`}</td>
                          <td>{tx.phone}</td>
                          <td>{tx.amount_paid}</td>
                          {/* <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}> */}
                          {/*  {tx.status} */}
                          {/* </td> */}
                        </tr>
                      </React.Fragment>
                    );
                  }
                  return (
                    <tr key={index}>
                      <td>{tx.transaction_id}</td>
                      <td>{tx.customer_type}</td>
                      <td>{`${tx.customer_lastname} ${tx.customer_firstname}`}</td>
                      <td>{tx.phone}</td>
                      <td>{tx.amount_paid}</td>
                      <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                        {tx.status}
                      </td>
                    </tr>
                  );
                })}
              {!loading && data && data.data.data.length === 0 && (
                <tr>
                  <td colSpan={7} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
          {tableView === 'searching' && (
            <tbody>
              {searchError && (
                <tr>
                  <td colSpan={6}>
                    <div className="d-flex justify-content-center w-100">
                      <p className="text-danger">{searchError}</p>
                    </div>
                  </td>
                </tr>
              )}
              {loadingSearch && (
                <tr className="py-3">
                  <td colSpan={6}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {!loadingSearch &&
                searchResult &&
                searchResult.length > 0 &&
                searchResult.map((tx, index) => (
                  <tr key={index}>
                    <td>{tx.transaction_id}</td>
                    <td>{tx.customer_type}</td>
                    <td>
                      {tx.customer_lastname} {tx.customer_firstname}
                    </td>
                    <td>{tx.phone}</td>
                    <td>{tx.amount_paid}</td>
                    <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                      {tx.status}
                    </td>
                  </tr>
                ))}
              {!loadingSearch && searchResult && searchResult.length === 0 && (
                <tr>
                  <td colSpan={7} className="w-100 text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          )}
          {tableView === 'filtering' && (
            <tbody>
              {filterError && (
                <tr>
                  <td colSpan={6}>
                    <div className="d-flex justify-content-center w-100">
                      <p className="text-danger">{filterError}</p>
                    </div>
                  </td>
                </tr>
              )}
              {filterLoading && (
                <tr className="py-3">
                  <td colSpan={6}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {!filterLoading &&
                filterResult &&
                filterResult.length > 0 &&
                filterResult.map((tx, index) => (
                  <tr key={index}>
                    <td>{tx.transaction_id}</td>
                    <td>{tx.customer_type}</td>
                    <td>
                      {tx.customer_lastname} {tx.customer_firstname}
                    </td>
                    <td>{tx.phone}</td>
                    <td>{tx.amount_paid} Kg</td>
                    <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                      {tx.status}
                    </td>
                  </tr>
                ))}
              {!filterLoading && filterResult && filterResult.length === 0 && (
                <tr>
                  <td colSpan={7} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>
      {tableView === 'normal' && data && (
        <LongPaginationHandler
          elementsPerPage={data.data.per_page}
          totalElements={data.data.total}
          activePage={page}
          paginate={paginate}
        />
      )}
      {tableView === 'filtering' && data && (
        <LongPaginationHandler
          elementsPerPage={filterPerPage}
          totalElements={filterTotal}
          activePage={filterPage}
          paginate={paginateFilter}
        />
      )}
    </div>
  );
};

export default DebtRepayment;
